import {Pipe, PipeTransform} from '@angular/core';
import {AuditLogVO} from '../../../generate/AuditLogVO';

@Pipe({
    name: 'auditLogFilter',
    standalone: false
})
export class AuditLogFilterPipe implements PipeTransform {
  transform(auditLogVOS: AuditLogVO[], type: string): any {

    if (!auditLogVOS) {
      return [];
    }
    return auditLogVOS.filter(log => log.type === type);
  }


}
